// src/utils/tabLocalStorage.js

const ORGANISATION_KEY = "OrganisationID";
const TAB_ID_KEY = "__QQ_TAB_ID__";

/**
 * Create/get a unique ID for this browser tab.
 *
 * IMPORTANT:
 * We are NOT storing OrganisationID in sessionStorage.
 * sessionStorage is used only to identify the current tab.
 *
 * Actual OrganisationID is stored in localStorage.
 */
const getTabId = () => {
  let tabId = sessionStorage.getItem(TAB_ID_KEY);

  if (!tabId) {
    tabId = `tab_${crypto.randomUUID()}`;
    sessionStorage.setItem(TAB_ID_KEY, tabId);
  }

  return tabId;
};

const tabId = getTabId();

/**
 * Generate tab-specific localStorage key.
 *
 * Example:
 *
 * OrganisationID_tab_abc123
 * OrganisationID_tab_xyz789
 */
const getOrganisationStorageKey = () => {
  return `${ORGANISATION_KEY}_${tabId}`;
};

/**
 * Save original browser Storage methods.
 */
const originalGetItem = Storage.prototype.getItem;
const originalSetItem = Storage.prototype.setItem;
const originalRemoveItem = Storage.prototype.removeItem;
const originalClear = Storage.prototype.clear;

/**
 * localStorage.getItem()
 */
Storage.prototype.getItem = function (key) {
  /**
   * Only intercept OrganisationID from localStorage.
   *
   * Everything else works exactly as before.
   */
  if (
    this === window.localStorage &&
    key === ORGANISATION_KEY
  ) {
    return originalGetItem.call(
      this,
      getOrganisationStorageKey()
    );
  }

  return originalGetItem.call(this, key);
};

/**
 * localStorage.setItem()
 */
Storage.prototype.setItem = function (key, value) {
  /**
   * Only intercept OrganisationID from localStorage.
   */
  if (
    this === window.localStorage &&
    key === ORGANISATION_KEY
  ) {
    return originalSetItem.call(
      this,
      getOrganisationStorageKey(),
      value
    );
  }

  return originalSetItem.call(this, key, value);
};

/**
 * localStorage.removeItem()
 */
Storage.prototype.removeItem = function (key) {
  /**
   * Only intercept OrganisationID from localStorage.
   */
  if (
    this === window.localStorage &&
    key === ORGANISATION_KEY
  ) {
    return originalRemoveItem.call(
      this,
      getOrganisationStorageKey()
    );
  }

  return originalRemoveItem.call(this, key);
};

/**
 * localStorage.clear()
 *
 * IMPORTANT:
 * We should NOT allow localStorage.clear()
 * to remove other users/login data accidentally.
 *
 * Therefore we keep normal clear() behaviour.
 *
 * If your application calls localStorage.clear()
 * during logout, see the logout note below.
 */
Storage.prototype.clear = function () {
  return originalClear.call(this);
};

/**
 * Debug helper.
 *
 * You can remove this later.
 */
window.__QQ_TAB_ID__ = tabId;

console.log("QQ Tab ID:", tabId);
console.log(
  "QQ Organisation Storage Key:",
  getOrganisationStorageKey()
);